(function () {
  const CHECKOUT_PATH = "/pages/qpay-checkout";
  const DEFAULT_BUY_NOW_PRODUCT_HANDLE = "gerhub-litter";
  const BUNDLE_PRODUCT_HANDLES = ["босоо-led-гэрэл"];
  const LABEL_TRANSLATIONS = [
    {
      from: /add\s+to\s+cart/gi,
      to: "Сагсанд нэмэх",
    },
    {
      from: /buy\s+it\s+now/gi,
      to: "Шууд захиалах",
    },
  ];
  const STOREFRONT_TRANSLATIONS = {
    "your cart": "Таны сагс",
    "continue shopping": "Худалдан авалтаа үргэлжлүүлэх",
    "product": "Бүтээгдэхүүн",
    "quantity": "Тоо ширхэг",
    "total": "Нийт",
    "order special instructions": "Захиалгын нэмэлт тайлбар",
    "estimated total": "Тооцоолсон нийт дүн",
    "taxes, discounts and shipping calculated at checkout.":
      "Татвар, хөнгөлөлт болон хүргэлтийн үнийг төлбөрийн үед тооцно.",
    "check out": "Төлбөр төлөх",
    "checkout": "Төлбөр төлөх",
    "contact": "Холбоо барих",
    "name": "Нэр",
    "email *": "И-мэйл *",
    "phone number": "Утасны дугаар",
    "comment": "Санал хүсэлт",
    "send": "Илгээх",
  };

  function buildCheckoutUrl(variantId, quantity) {
    const url = new URL(window.location.origin + CHECKOUT_PATH);

    if (variantId) {
      url.searchParams.set("add", variantId);
    }

    if (quantity) {
      url.searchParams.set("qty", quantity);
    }

    return url.pathname + url.search;
  }

  function getLocaleAwareUrl(path) {
    const rootPath =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    return rootPath + path.replace(/^\//, "");
  }

  function resolveProductForm(trigger) {
    if (!trigger) {
      return null;
    }

    const closestForm = trigger.closest('form[action*="/cart/add"]');

    if (closestForm) {
      return closestForm;
    }

    if (trigger.form && /\/cart\/add(?:\.js)?(?:\/|\?|#|$)/.test(trigger.form.getAttribute("action") || "")) {
      return trigger.form;
    }

    const formId = trigger.getAttribute("form");

    if (formId) {
      const linkedForm = document.getElementById(formId);

      if (linkedForm && /\/cart\/add(?:\.js)?(?:\/|\?|#|$)/.test(linkedForm.getAttribute("action") || "")) {
        return linkedForm;
      }
    }

    const productContainer = trigger.closest(
        [
          "product-form",
          "product-info",
          ".product",
          ".product-form",
          ".product__info-container",
          '[id^="ProductInfo-"]',
          '[data-section-type*="product" i]',
          '[data-section*="product" i]',
        ].join(",")
    );

    if (productContainer) {
      const containerForm = productContainer.querySelector('form[action*="/cart/add"]');

      if (containerForm) {
        return containerForm;
      }
    }

    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    return productForms.length === 1 ? productForms[0] : null;
  }

  function resolveVariantId(trigger) {
    const explicit = trigger.getAttribute("data-variant-id");

    if (explicit) {
      return explicit;
    }

    const form = resolveProductForm(trigger);
    const input = form ? form.querySelector('[name="id"]') : null;

    if (input && input.value) {
      return input.value;
    }

    const section = trigger.closest("[data-section], section, main") || document;
    const fallback = section.querySelector('[name="id"], [data-variant-id], [data-product-variant-id]');

    if (!fallback) {
      return "";
    }

    return fallback.value || fallback.getAttribute("data-variant-id") || fallback.getAttribute("data-product-variant-id") || "";
  }

  function normalizeVariantId(value) {
    const normalized = String(value || "").trim();
    const gidMatch = /ProductVariant\/(\d+)$/.exec(normalized);

    return gidMatch ? gidMatch[1] : normalized;
  }

  function getVariantIdFromUrl(value) {
    if (!value) {
      return "";
    }

    try {
      const url = new URL(value, window.location.origin);
      return normalizeVariantId(url.searchParams.get("variant") || url.searchParams.get("add"));
    } catch (_error) {
      return "";
    }
  }

  function getProductHandleFromUrl(value) {
    if (!value) {
      return "";
    }

    try {
      const url = new URL(value, window.location.origin);
      const match = /\/products\/([^/?#]+)/.exec(url.pathname);
      return match ? decodeURIComponent(match[1]) : "";
    } catch (_error) {
      return "";
    }
  }

  function resolveProductHandle(trigger) {
    const explicit =
      trigger.getAttribute("data-product-handle") ||
      trigger.getAttribute("data-handle") ||
      "";

    if (explicit) {
      return explicit;
    }

    const directUrls = [
      trigger.getAttribute("data-product-url"),
      trigger.getAttribute("href"),
      window.location.pathname,
    ];

    for (let index = 0; index < directUrls.length; index += 1) {
      const handle = getProductHandleFromUrl(directUrls[index]);

      if (handle) {
        return handle;
      }
    }

    const section = trigger.closest("[data-section-id], .shopify-section, section");
    const scopes = section ? [section, document] : [document];

    for (let index = 0; index < scopes.length; index += 1) {
      const handles = new Set();

      scopes[index].querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        const handle = getProductHandleFromUrl(link.getAttribute("href"));

        if (handle) {
          handles.add(handle);
        }
      });

      if (handles.size === 1) {
        return Array.from(handles)[0];
      }
    }

    return "";
  }

  async function fetchVariantIdByHandle(handle) {
    if (!handle) {
      return "";
    }

    const response = await fetch(
      getLocaleAwareUrl("/products/" + encodeURIComponent(handle) + ".js"),
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      return "";
    }

    const product = await response.json();
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const selected = variants.find(function (variant) {
      return variant.available;
    }) || variants[0];

    return selected ? normalizeVariantId(selected.id) : "";
  }

  async function fetchOnlyAvailableStoreVariantId() {
    const response = await fetch(getLocaleAwareUrl("/products.json?limit=2"), {
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      return "";
    }

    const payload = await response.json();
    const products = Array.isArray(payload.products) ? payload.products : [];
    const availableProducts = products.filter(function (product) {
      return Array.isArray(product.variants) && product.variants.some(function (variant) {
        return variant.available;
      });
    });

    if (availableProducts.length !== 1) {
      return "";
    }

    const variant = availableProducts[0].variants.find(function (item) {
      return item.available;
    });

    return variant ? normalizeVariantId(variant.id) : "";
  }

  async function resolveVariantIdForBuyNow(trigger) {
    const directVariantId =
      normalizeVariantId(resolveVariantId(trigger)) ||
      getVariantIdFromUrl(trigger.getAttribute("href")) ||
      getVariantIdFromUrl(trigger.getAttribute("data-product-url"));

    if (directVariantId) {
      return directVariantId;
    }

    const handle = resolveProductHandle(trigger) || DEFAULT_BUY_NOW_PRODUCT_HANDLE;
    const handleVariantId = await fetchVariantIdByHandle(handle);

    if (handleVariantId) {
      return handleVariantId;
    }

    return fetchOnlyAvailableStoreVariantId();
  }

  function resolveQuantity(trigger) {
    const explicit = trigger.getAttribute("data-quantity");

    if (explicit) {
      return explicit;
    }

    const form = resolveProductForm(trigger);
    const input = form ? form.querySelector('[name="quantity"]') : null;
    return input ? input.value : "1";
  }

  function formatBundleMoney(amount) {
    return new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 0,
    }).format(Math.max(0, Number(amount) || 0)) + "₮";
  }

  function addBundleSelectorStyles() {
    if (document.getElementById("qpay-bundle-selector-styles")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "qpay-bundle-selector-styles";
    style.textContent = `
      .qpay-bundle-selector {
        display: grid;
        gap: 12px;
        margin: 22px 0 18px;
      }
      .qpay-bundle-selector__heading {
        display: flex;
        align-items: center;
        gap: 14px;
        color: #111;
        font-size: 15px;
        font-weight: 800;
        line-height: 1.2;
        text-align: center;
      }
      .qpay-bundle-selector__heading::before,
      .qpay-bundle-selector__heading::after {
        content: "";
        height: 2px;
        flex: 1 1 auto;
        background: #111;
      }
      .qpay-bundle-selector__option {
        appearance: none;
        position: relative;
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        align-items: center;
        gap: 14px;
        width: 100%;
        min-height: 76px;
        padding: 14px 16px 14px 48px;
        border: 1.5px solid #c9c9c9;
        border-radius: 12px;
        background: #fff;
        color: #111;
        cursor: pointer;
        font: inherit;
        text-align: left;
        transition: border-color .18s ease, box-shadow .18s ease, background .18s ease;
      }
      .qpay-bundle-selector__option::before {
        content: "";
        position: absolute;
        left: 20px;
        top: 50%;
        width: 20px;
        height: 20px;
        border: 2px solid #b6b6b6;
        border-radius: 50%;
        background: #fff;
        transform: translateY(-50%);
        box-sizing: border-box;
      }
      .qpay-bundle-selector__option[aria-checked="true"] {
        border-color: #111;
        background: #f7f7f7;
        box-shadow: 0 0 0 1px #111;
      }
      .qpay-bundle-selector__option[aria-checked="true"]::before {
        border: 6px solid #111;
      }
      .qpay-bundle-selector__copy,
      .qpay-bundle-selector__price {
        display: grid;
        gap: 4px;
      }
      .qpay-bundle-selector__copy {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
      }
      .qpay-bundle-selector__title-row {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
      }
      .qpay-bundle-selector__title {
        font-size: 19px;
        font-weight: 800;
        line-height: 1.15;
      }
      .qpay-bundle-selector__count {
        padding: 0;
        border: 0;
        font-size: 14px;
        font-weight: 700;
        white-space: nowrap;
      }
      .qpay-bundle-selector__saving {
        padding: 5px 9px;
        border-radius: 999px;
        background: #16a34a;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.25;
      }
      .qpay-bundle-selector__price {
        justify-items: end;
        text-align: right;
      }
      .qpay-bundle-selector__current {
        font-size: 19px;
        font-weight: 900;
        line-height: 1.1;
        white-space: nowrap;
      }
      .qpay-bundle-selector__compare {
        color: #666;
        font-size: 14px;
        text-decoration: line-through;
        white-space: nowrap;
      }
      .qpay-bundle-selector__badge {
        position: absolute;
        top: -10px;
        right: 14px;
        padding: 5px 11px;
        border-radius: 4px;
        background: #111;
        color: #fff;
        font-size: 11px;
        font-weight: 800;
        line-height: 1;
        letter-spacing: .02em;
      }
      .qpay-bundle-selector__option:focus-visible {
        outline: 3px solid rgba(17, 17, 17, .24);
        outline-offset: 2px;
      }
      @media (max-width: 480px) {
        .qpay-bundle-selector__option {
          min-height: 76px;
          padding: 14px 12px 14px 46px;
          gap: 8px;
        }
        .qpay-bundle-selector__option::before {
          left: 15px;
          width: 18px;
          height: 18px;
        }
        .qpay-bundle-selector__title,
        .qpay-bundle-selector__current {
          font-size: 16px;
        }
        .qpay-bundle-selector__saving,
        .qpay-bundle-selector__compare {
          font-size: 12px;
        }
        .qpay-bundle-selector__count {
          padding: 0;
          font-size: 13px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function setProductQuantity(productScope, quantity) {
    const normalizedQuantity = String(quantity);
    const quantityInputs = Array.from(
      productScope.querySelectorAll('input[name="quantity"]')
    );

    if (quantityInputs.length === 0) {
      const linkedFormId = productScope.querySelector('form[action*="/cart/add"]')?.id;

      if (linkedFormId) {
        document
          .querySelectorAll('input[name="quantity"][form="' + CSS.escape(linkedFormId) + '"]')
          .forEach(function (input) {
            quantityInputs.push(input);
          });
      }
    }

    quantityInputs.forEach(function (input) {
      input.value = normalizedQuantity;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    productScope
      .querySelectorAll(
        '.shopify-payment-button__button, .shopify-payment-button button, button[name="add"], [data-qpay-redirect]'
      )
      .forEach(function (button) {
        button.setAttribute("data-quantity", normalizedQuantity);
      });
  }

  function selectBundleOption(selector, productScope, quantity) {
    selector.querySelectorAll("[data-bundle-quantity]").forEach(function (option) {
      const isSelected = option.getAttribute("data-bundle-quantity") === String(quantity);
      option.setAttribute("aria-checked", isSelected ? "true" : "false");
    });

    setProductQuantity(productScope, quantity);
  }

  function buildBundleOption(quantity, price, compareAtPrice) {
    const badges = {
      2: "ХАМГИЙН ЭРЭЛТТЭЙ",
      3: "ШИЛДЭГ СОНГОЛТ",
    };
    const total = price * quantity;
    const compareTotal = compareAtPrice * quantity;
    const saving = Math.max(0, compareTotal - total);
    const option = document.createElement("button");
    option.type = "button";
    option.className = "qpay-bundle-selector__option";
    option.setAttribute("role", "radio");
    option.setAttribute("aria-checked", quantity === 1 ? "true" : "false");
    option.setAttribute("data-bundle-quantity", String(quantity));
    option.innerHTML = `
      <span class="qpay-bundle-selector__copy">
        <span class="qpay-bundle-selector__title-row">
          <span class="qpay-bundle-selector__count">${quantity} ширхэг</span>
        </span>
        <span class="qpay-bundle-selector__saving">Хэмнэлт ${formatBundleMoney(saving)}</span>
      </span>
      <span class="qpay-bundle-selector__price">
        <span class="qpay-bundle-selector__current">${formatBundleMoney(total)}</span>
        ${compareTotal > total ? `<span class="qpay-bundle-selector__compare">${formatBundleMoney(compareTotal)}</span>` : ""}
      </span>
      ${badges[quantity] ? `<span class="qpay-bundle-selector__badge">${badges[quantity]}</span>` : ""}
    `;
    return option;
  }

  async function initializeBundleSelector() {
    const handle = getProductHandleFromUrl(window.location.href).toLowerCase();

    if (!handle) return;

    const productScope =
      document.querySelector("product-info") ||
      document.querySelector('[id^="ProductInfo-"]') ||
      document.querySelector(".product__info-container");

    if (!productScope || productScope.querySelector("[data-qpay-bundle-selector]")) {
      return;
    }

    const productForm = productScope.querySelector('form[action*="/cart/add"]');
    const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
    const variantId = normalizeVariantId(variantInput ? variantInput.value : "");
    let product;

    try {
      const response = await fetch(
        getLocaleAwareUrl("/products/" + encodeURIComponent(handle) + ".js"),
        { headers: { Accept: "application/json" } }
      );

      if (!response.ok) {
        return;
      }

      product = await response.json();
    } catch (_error) {
      return;
    }

    const isLight = /гэрэл|lighting/i.test(product.title + " " + product.type) ||
      BUNDLE_PRODUCT_HANDLES.includes(handle);
    const isWatch = /цаг/.test(product.title || "");
    if (!isLight && !isWatch) return;

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const variant = variants.find(function (item) {
      return normalizeVariantId(item.id) === variantId;
    }) || variants.find(function (item) {
      return item.available;
    }) || variants[0];

    if (!variant) {
      return;
    }

    const price = Number(variant.price || 0) / 100;
    const compareAtPrice = Math.max(
      price,
      Number(variant.compare_at_price || variant.price || 0) / 100
    );
    const selector = document.createElement("div");
    selector.className = "qpay-bundle-selector";
    selector.setAttribute("data-qpay-bundle-selector", "");
    selector.setAttribute("role", "radiogroup");
    selector.setAttribute("aria-label", "Тоо ширхэгийн багц сонгох");

    const heading = document.createElement("div");
    heading.className = "qpay-bundle-selector__heading";
    heading.textContent = "Олноор авахад илүү ашигтай";
    selector.appendChild(heading);

    (isWatch ? [1, 2, 3] : [1, 2]).forEach(function (quantity) {
      const option = buildBundleOption(quantity, price, compareAtPrice);
      option.addEventListener("click", function () {
        selectBundleOption(selector, productScope, quantity);
      });
      selector.appendChild(option);
    });

    addBundleSelectorStyles();

    const quantityInput = productScope.querySelector('input[name="quantity"]');
    const quantityBlock = quantityInput
      ? quantityInput.closest(".product-form__quantity") || quantityInput.closest("quantity-input")
      : null;
    const insertBefore = quantityBlock || productForm;

    if (!insertBefore || !insertBefore.parentNode) {
      return;
    }

    insertBefore.parentNode.insertBefore(selector, insertBefore);

    if (quantityBlock) {
      quantityBlock.hidden = true;
    }

    selectBundleOption(selector, productScope, 1);
  }

  function extractPropertyKey(name) {
    const match = /^properties\[(.+)\]$/.exec(name || "");
    return match ? match[1] : "";
  }

  function isUploadRelatedName(value) {
    return /upload|file|image|photo|poster|original|zurag/i.test(value || "");
  }

  function isLikelyFileUrl(value) {
    return (
      typeof value === "string" &&
      /^https?:\/\//i.test(value) &&
      /\.(jpg|jpeg|png|webp|gif|heic|pdf|svg|zip)(?:\?|#|$)/i.test(value)
    );
  }

  function collectUploadPropertyFallbacks(form) {
    const container =
      form.closest("product-form-component") ||
      form.closest("[data-product-root]") ||
      form.closest(".product") ||
      form.closest("main") ||
      document;
    const fileNames = new Set();
    const fileUrls = new Set();

    container.querySelectorAll('input[type="file"]').forEach(function (input) {
      Array.from(input.files || []).forEach(function (file) {
        if (file && file.name) {
          fileNames.add(file.name);
        }
      });
    });

    container
      .querySelectorAll('input[type="hidden"], input[type="text"], a[href], [data-file-name], [data-upload-name], [data-upload-url], [data-file-url]')
      .forEach(function (node) {
        const nodeName =
          node.getAttribute("name") ||
          node.getAttribute("id") ||
          node.getAttribute("class") ||
          node.getAttribute("data-file-name") ||
          node.getAttribute("data-upload-name") ||
          node.getAttribute("data-upload-url") ||
          node.getAttribute("data-file-url") ||
          "";
        const value =
          node.value ||
          node.getAttribute("href") ||
          node.getAttribute("data-file-name") ||
          node.getAttribute("data-upload-name") ||
          node.getAttribute("data-upload-url") ||
          node.getAttribute("data-file-url") ||
          node.textContent ||
          "";

        if (!String(value || "").trim()) {
          return;
        }

        if (isLikelyFileUrl(value)) {
          fileUrls.add(String(value).trim());

          const parts = String(value).split("/").filter(Boolean);
          const lastPart = parts[parts.length - 1];

          if (lastPart) {
            fileNames.add(decodeURIComponent(lastPart.split("?")[0]));
          }

          return;
        }

        if (!isUploadRelatedName(nodeName)) {
          return;
        }

        const trimmed = String(value).trim();

        if (/\.(jpg|jpeg|png|webp|gif|heic|pdf|svg|zip)$/i.test(trimmed)) {
          fileNames.add(trimmed.split(/[\\/]/).pop());
        }
      });

    const properties = {};

    if (fileNames.size > 0) {
      const list = Array.from(fileNames);
      properties.upload_file_names = list.join(", ");
      properties.upload_file_name = list[0];
    }

    if (fileUrls.size > 0) {
      const list = Array.from(fileUrls);
      properties.upload_file_urls = list.join(", ");
      properties.upload_file_url = list[0];
    }

    if (fileNames.size > 0 || fileUrls.size > 0) {
      properties.upload_bridge_source = "theme-qpay-entry";
    }

    return properties;
  }

  function buildCartAddPayload(form, trigger, resolvedVariantId) {
    const variantId = resolvedVariantId || resolveVariantId(trigger);
    const quantity = Number(resolveQuantity(trigger) || "1");
    const properties = {};
    const formData = form ? new FormData(form) : null;

    if (formData) {
      formData.forEach(function (value, key) {
        const propertyKey = extractPropertyKey(key);

        if (!propertyKey) {
          return;
        }

        const stringValue = typeof value === "string" ? value.trim() : "";

        if (stringValue) {
          properties[propertyKey] = stringValue;
        }
      });
    }

    const fallbackProperties = form ? collectUploadPropertyFallbacks(form) : {};

    Object.keys(fallbackProperties).forEach(function (key) {
      if (!properties[key] && fallbackProperties[key]) {
        properties[key] = fallbackProperties[key];
      }
    });

    return {
      items: [
        {
          id: Number(variantId),
          quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
          properties: properties
        }
      ]
    };
  }

  async function addProductToCartForQPay(trigger, resolvedVariantId) {
    const form = resolveProductForm(trigger);
    const variantId = normalizeVariantId(resolvedVariantId || resolveVariantId(trigger));

    if (!variantId) {
      throw new Error(
        "Захиалах бүтээгдэхүүн олдсонгүй. Товчинд product link эсвэл data-product-handle тохируулна уу."
      );
    }

    const payload = buildCartAddPayload(form, trigger, variantId);
    const response = await fetch(getLocaleAwareUrl("/cart/add.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      let message = "Cart add failed";

      try {
        const errorPayload = await response.json();
        message = errorPayload.description || errorPayload.message || message;
      } catch (_jsonError) {
        message = await response.text();
      }

      throw new Error(message);
    }
  }

  function goToQPayCheckout() {
    window.location.href = CHECKOUT_PATH;
  }

  async function redirectProductToQPay(trigger) {
    trigger.setAttribute("aria-busy", "true");

    if ("disabled" in trigger) {
      trigger.disabled = true;
    }

    try {
      const variantId = await resolveVariantIdForBuyNow(trigger);
      await addProductToCartForQPay(trigger, variantId);
      goToQPayCheckout();
    } catch (error) {
      console.error("[qpay-entry] Failed to prepare product for QPay checkout", error);
      trigger.removeAttribute("aria-busy");

      if ("disabled" in trigger) {
        trigger.disabled = false;
      }
    }
  }

  function hasCheckoutPath(value) {
    if (!value) {
      return false;
    }

    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, "") === "/checkout";
    } catch (error) {
      return /\/checkout(?:\/|\?|#|$)/.test(value);
    }
  }

  function isCartContext(trigger) {
    return Boolean(
        trigger &&
        trigger.closest(
            [
              "cart-drawer",
              "cart-items-component",
              ".cart",
              ".cart-drawer",
              ".drawer",
              ".cart__ctas",
              ".cart__footer",
              ".cart-summary",
              '[id*="cart" i]',
              '[class*="cart" i]',
            ].join(",")
        )
    );
  }

  function getElementLabel(trigger) {
    if (!trigger) {
      return "";
    }

    return [
      trigger.textContent || "",
      trigger.getAttribute("value") || "",
      trigger.getAttribute("aria-label") || "",
      trigger.getAttribute("data-testid") || "",
    ]
        .join(" ")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
  }

  function translateValue(value) {
    if (!value) {
      return value;
    }

    return LABEL_TRANSLATIONS.reduce(function (text, translation) {
      return text.replace(translation.from, translation.to);
    }, value);
  }

  function translateExactValue(value) {
    const original = String(value || "");
    const trimmed = original.replace(/\s+/g, " ").trim();
    const translated = STOREFRONT_TRANSLATIONS[trimmed.toLowerCase()];

    if (!translated) {
      return original;
    }

    return original.replace(original.trim(), translated);
  }

  function translateStorefrontElement(element) {
    if (!(element instanceof Element)) {
      return;
    }

    if (element.matches("script, style, noscript, template")) {
      return;
    }

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        const parent = node.parentElement;

        if (!parent || parent.matches("script, style, noscript, template")) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      },
    });
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(function (node) {
      const translated = translateExactValue(node.nodeValue);

      if (translated !== node.nodeValue) {
        node.nodeValue = translated;
      }
    });

    const translatableElements = [element].concat(
      Array.from(element.querySelectorAll("[placeholder], [aria-label], [title], input[value]"))
    );

    translatableElements.forEach(function (node) {
      ["placeholder", "aria-label", "title", "value"].forEach(function (attribute) {
        if (!node.hasAttribute(attribute)) {
          return;
        }

        const value = node.getAttribute(attribute);
        const translated = translateExactValue(value);

        if (translated !== value) {
          node.setAttribute(attribute, translated);
        }
      });
    });
  }

  function translateElementText(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(function (node) {
      const translated = translateValue(node.nodeValue || "");

      if (translated !== node.nodeValue) {
        node.nodeValue = translated;
      }
    });

    ["aria-label", "title", "value"].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) {
        return;
      }

      const value = element.getAttribute(attribute);
      const translated = translateValue(value);

      if (translated !== value) {
        element.setAttribute(attribute, translated);
      }
    });
  }

  function translateProductButtonLabels(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const selector = [
      'form[action*="/cart/add"] button',
      'form[action*="/cart/add"] input[type="submit"]',
      ".shopify-payment-button__button",
      ".shopify-payment-button button",
      "button[name='add']",
      "[data-add-to-cart]",
      "[data-testid*='buy' i]",
      "[aria-label*='buy it now' i]",
    ].join(",");

    if (scope instanceof Element && scope.matches(selector)) {
      translateElementText(scope);
    }

    scope.querySelectorAll(selector).forEach(translateElementText);
  }

  function hasCheckoutLabel(trigger) {
    const label = getElementLabel(trigger);

    return [
      "checkout",
      "check out",
      "төлбөр төлөх",
      "захиалга баталгаажуулах",
      "үргэлжлүүлэх",
    ].some(function (text) {
      return label.includes(text);
    });
  }

  function isBuyNowButton(trigger) {
    if (!trigger) {
      return false;
    }

    const label = getElementLabel(trigger);

    return (
        trigger.matches(".shopify-payment-button__button, .shopify-payment-button button") ||
        trigger.closest(".shopify-payment-button") ||
        label.includes("buy it now") ||
        label.includes("шууд худалдаж авах") ||
        label.includes("шууд захиалах")
    );
  }

  function isCheckoutLink(trigger) {
    if (!trigger || trigger.tagName !== "A") {
      return false;
    }

    const href = trigger.getAttribute("href") || "";
    return hasCheckoutPath(href) || (isCartContext(trigger) && hasCheckoutLabel(trigger));
  }

  function isCheckoutButton(trigger) {
    if (!trigger) {
      return false;
    }

    const name = (trigger.getAttribute("name") || "").toLowerCase();
    const id = (trigger.getAttribute("id") || "").toLowerCase();
    const type = (trigger.getAttribute("type") || "").toLowerCase();
    const form = trigger.closest("form");
    const formAction = form ? form.getAttribute("action") || "" : "";

    return (
        name === "checkout" ||
        id === "checkout" ||
        trigger.hasAttribute("data-checkout-button") ||
        trigger.matches(".cart__checkout-button, [data-cart-checkout], .wt-cart__cta, .cart__checkout") ||
        (type === "submit" && /\/cart(?:\/|\?|#|$)/.test(formAction) && hasCheckoutLabel(trigger)) ||
        (isCartContext(trigger) && hasCheckoutLabel(trigger))
    );
  }

  function getTriggerSelector() {
    return [
      "[data-qpay-redirect]",
      ".shopify-payment-button__button",
      ".shopify-payment-button button",
      "a",
      "button",
      "input[type='submit']",
      "[role='button']",
      "[data-testid*='checkout' i]",
      "[data-testid*='buy' i]",
      "[aria-label*='buy it now' i]",
      "[class*='checkout' i]",
      "[class*='continue' i]",
      ".wt-cart__cta",
      ".cart__checkout",
    ].join(",");
  }

  function resolveCheckoutTriggerFromNode(node) {
    if (!(node instanceof Element)) {
      return null;
    }

    return node.closest(getTriggerSelector());
  }

  function resolveCheckoutTrigger(event) {
    const path = typeof event.composedPath === "function" ? event.composedPath() : [];

    for (let index = 0; index < path.length; index += 1) {
      const trigger = resolveCheckoutTriggerFromNode(path[index]);

      if (trigger) {
        return trigger;
      }
    }

    return resolveCheckoutTriggerFromNode(event.target);
  }

  function stopNativeCheckout(event) {
    event.preventDefault();

    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    } else {
      event.stopPropagation();
    }
  }

  function handleCheckoutIntent(event) {
    const trigger = resolveCheckoutTrigger(event);

    if (!trigger) {
      return;
    }

    if (isBuyNowButton(trigger)) {
      stopNativeCheckout(event);

      if (trigger.getAttribute("aria-busy") === "true") {
        return;
      }

      redirectProductToQPay(trigger);
      return;
    }

    if (isCheckoutLink(trigger) || isCheckoutButton(trigger)) {
      stopNativeCheckout(event);
      goToQPayCheckout();
      return;
    }

    if (!trigger.matches("[data-qpay-redirect]")) {
      return;
    }

    stopNativeCheckout(event);

    if (trigger.getAttribute("aria-busy") === "true") {
      return;
    }

    redirectProductToQPay(trigger);
  }

  document.addEventListener("click", handleCheckoutIntent, true);

  document.addEventListener("submit", function (event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const action = form.getAttribute("action") || "";
    const submitter = event.submitter instanceof Element ? event.submitter : null;
    const isCheckoutSubmit = submitter ? isCheckoutButton(submitter) : Boolean(form.querySelector('[name="checkout"]'));

    if (/\/cart(?:\/|\?|#|$)/.test(action) && isCheckoutSubmit) {
      stopNativeCheckout(event);
      goToQPayCheckout();
    }
  }, true);

  document.addEventListener(
      "touchend",
      handleCheckoutIntent,
      { passive: false, capture: true }
  );

  document.addEventListener(
      "pointerup",
      handleCheckoutIntent,
      true
  );

  initializeBundleSelector();
  translateProductButtonLabels(document);
  translateStorefrontElement(document.documentElement);

  document.addEventListener("DOMContentLoaded", function () {
    initializeBundleSelector();
    translateProductButtonLabels(document);
    translateStorefrontElement(document.documentElement);
  });

  document.addEventListener("shopify:section:load", function () {
    initializeBundleSelector();
  });

  if ("MutationObserver" in window) {
    const labelObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element) {
            translateProductButtonLabels(node);
            translateStorefrontElement(node);
          }
        });
      });
    });

    labelObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
